export default __webpack_public_path__ + "static/media/孙畅半身像.443dd69a.png";